// src/services/notificationService.js
import api from './api';

// Uses the shared axios instance from ./api — the request interceptor there
// attaches the bearer token, so no manual header wiring is needed here.
const notificationService = {
  // Get all notifications
  getNotifications: async (page = 1, limit = 20, unreadOnly = false) => {
    const params = { page, limit };
    if (unreadOnly) params.unread = true;

    const response = await api.get('/notifications', { params });
    return response.data;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data.count;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all as read
  markAllAsRead: async () => {
    const response = await api.patch('/notifications/mark-all-read');
    return response.data;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  },

  // Clear all read notifications
  clearRead: async () => {
    const response = await api.delete('/notifications/clear-read');
    return response.data;
  },

  // Create notification (admin only, for testing)
  createNotification: async (notificationData) => {
    const response = await api.post('/notifications', notificationData);
    return response.data;
  }
};

export default notificationService;
